import { CompanyAdminActionTypes } from './actionTypes';

type InitialState = {
  currentCompany: any;
  currentUser: any;
  companyId: string | null;
  userId: string | null;
  selectedUsers: MedScout.User[];
  selectedUser: MedScout.User | null;
};

export const initialCompanyAdminState: InitialState = {
  currentCompany: null,
  currentUser: null,
  companyId: null,
  userId: null,
  selectedUsers: [],
  selectedUser: null,
};

export const companyAdminReducer = (
  state = initialCompanyAdminState,
  action: any
) => {
  switch (action.type) {
    case CompanyAdminActionTypes.SET_CURRENT_COMPANY:
      return { ...state, currentCompany: action.payload };
    case CompanyAdminActionTypes.SET_CURRENT_USER:
      return { ...state, currentUser: action.payload };
    case CompanyAdminActionTypes.SET_CURRENT_COMPANY_AND_USER:
      return {
        ...state,
        currentCompany: action.payload.company,
        currentUser: action.payload.user,
      };
    case CompanyAdminActionTypes.SET_COMPANY_ID:
      return { ...state, companyId: action.payload };
    case CompanyAdminActionTypes.SET_USER_ID:
      return { ...state, userId: action.payload };
    case CompanyAdminActionTypes.SET_SELECTED_USERS:
      return { ...state, selectedUsers: action.payload };
    case CompanyAdminActionTypes.SET_SELECTED_USER:
      return { ...state, selectedUser: action.payload };
    default:
      return state;
  }
};
